import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type {
  TradeActiveTokenOrdersCreatePayload as TradeActiveTokenOrdersCreatePayloadDto,
  TradeOrdersCreatePayload as TradeOrdersCreatePayloadDto,
} from '@blade/trade-api-client'
import type { WalletId } from '@root/entities/wallet/model'

export interface TradeActiveTokenOrdersCreatePayload
  extends TypeHelper.OmitKey<
    TradeActiveTokenOrdersCreatePayloadDto,
    'walletIds'
  > {
  walletIds: Array<WalletId> | undefined
}

export const fetchActiveLimitOrdersTokensRequestAction = action(
  async (ctx, req: TradeActiveTokenOrdersCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.trade.tradeActiveTokenOrdersCreate, [req]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchActiveLimitOrdersTokensRequestAction',
)

interface TradeOrdersCreatePayload
  extends TypeHelper.OmitKey<
    TradeOrdersCreatePayloadDto,
    'network' | 'walletIds'
  > {
  network: Network.Network
  walletIds: Array<WalletId> | undefined
}

export const fetchUserOrdersRequestAction = action(
  async (ctx, { network, ...req }: TradeOrdersCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.trade.tradeOrdersCreate, [
        {
          ...req,
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchUserOrdersRequestAction',
)
